<template>
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-KeCanTing`]" width="1em" height="1em" v-bind="$attrs"><path d="M21.7969 17.625H2.20312C1.8148 17.625 1.5 17.3072 1.5 16.9189C1.5 11.1199 6.20101 6.375 12 6.375C17.799 6.375 22.5 11.1199 22.5 16.9189C22.5 17.3072 22.1852 17.625 21.7969 17.625Z" stroke="#333"/><path d="M1.5 19.875H22.5M3.75 15.75H20.25" stroke="#333" stroke-linecap="round"/><path d="M13.875 4.5C13.875 3.46447 13.0355 2.625 12 2.625C10.9645 2.625 10.125 3.46447 10.125 4.5C10.125 5.53553 10.9645 6.375 12 6.375C13.0355 6.375 13.875 5.53553 13.875 4.5Z" stroke="#333"/></svg>
</template>
<script>

export default {
  name: 'IconKeCanTing',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
